import { render, staticRenderFns } from "./seepersonface.vue?vue&type=template&id=00487f0a&scoped=true&"
import script from "./seepersonface.vue?vue&type=script&lang=js&"
export * from "./seepersonface.vue?vue&type=script&lang=js&"
import style0 from "./seepersonface.vue?vue&type=style&index=0&id=00487f0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00487f0a",
  null
  
)

export default component.exports